import React, { useEffect, useState } from "react";
import { FPaquetesStyle } from "./styles";
import { Grid, TextField, Button, InputAdornment } from "@material-ui/core";
import TablaFechas from "./TablaFechas";
import TablaRegitro from "./TablaRegistro";
import PickerMod from "../../../global/PickersMod";
import { ToastMessage } from "../../../global/ToastMessage";
import { FormatFecha, FormatoFecha, FormatoFechaIso } from "../../../utils/FormatFecha";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerSalidasByIdPaqueteAction,
  altaBloqueSalidasAction,
} from "../../../ducks/salidasDuck";
import { altaSalidaPaqueteAction } from "../../../ducks/paqueteDuck";
import BackDrop from "../../../global/BackDrop";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "../../../global/ModalBase";
const FPaquetesSalidas = (props) => {
  const { open = true, setOpen = () => { }, rowData = {} } = props;
  const dispatch = useDispatch();
  const salidasPaquetes = useSelector((state) => state.salidas.array);
  const classes = FPaquetesStyle();
  const [selectDay, setSelectedDate] = useState(new Date());
  const [arraySalidas, setArraySalidas] = useState([]);
  const [suplemento, setSuplemento] = useState(0);
  const [disponibilidad, setDisponibilidad] = useState(0);
  const [descripcion, setDescripcion] = useState("");
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerSalidasByIdPaqueteAction(rowData.IdPaquete)).then(
      (Response) => {
        setIsLoad(false);
      }
    );
  }, [dispatch, rowData.IdPaquete]);

  // const getFechas = (arrayFecha) => {
  //   return arrayFecha.map((item) => {
  //     return item.FechaSalida;
  //   });
  // };

  const onSave = () => {
    setIsLoad(true);
    let salidasObjectArray = arraySalidas.map(salida => {
      return {
        FechasSalida: salida.FechaSalida,
        Personas: salida.disponibilidad
      }
    })
    let bloque = {
      ClavePaquete: rowData?.ClavePaquete,
      Descripcion: descripcion,
      Suplemento: suplemento,
      lSalidas: salidasObjectArray,
    };
    dispatch(altaBloqueSalidasAction(bloque)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          LimpiarForm();
          let bloqueSalida = {
            IdPaquete: rowData.IdPaquete,
            IdBloque: Response.data,
          };
          dispatch(altaSalidaPaqueteAction(bloqueSalida)).then((respuesta) => {
            dispatch(obtenerSalidasByIdPaqueteAction(rowData.IdPaquete));
            ToastMessage.fire({
              icon: "success",
              title: "Ingreso Correcto",
            });
            setIsLoad(false);
          });
          break;
      }
    });
  };

  const onAgregar = () => {
    if (Number(disponibilidad) <= 0) {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "Agregar disponibilidad",
      });
      return null
    }

    const resultado = arraySalidas.find(
      (salida) => {
        return FormatoFechaIso({ date: salida.FechaSalida, formato: "MMddyyyy" }) === `${FormatoFecha({ date: selectDay, formato: "MMddyyyy" })}`
      }
    );
    if (!resultado) {
      let salida = {
        id: `${FormatoFecha({ date: selectDay, formato: "MMddyyyy" })}`,
        FechaSalida: `${FormatFecha(selectDay)}`,
        disponibilidad: disponibilidad
      };
      setArraySalidas([...arraySalidas, salida]);
    } else {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "Esta fecha ya fue asignada",
      });
    }
  };

  const LimpiarForm = () => {
    setDescripcion("");
    setSuplemento(0);
    setDisponibilidad(0)
    setSelectedDate(new Date());
    setArraySalidas([]);
  };

  const handleClose = () => {
    setOpen(!open);
    LimpiarForm();
  };
  const onDeleteFecha = (row) => {
    const array = arraySalidas.filter((salida) => salida.id !== row.id);
    setArraySalidas(array);
  };
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        titulo={`Salidas para el paqute  ${rowData.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={6}>
          <Grid container className={classes.containerSpacing}>
            <Grid item xs={12}>
              <TextField
                required
                id="input-descripcion"
                label="Descripción"
                type="text"
                variant="outlined"
                name="descripcion"
                value={descripcion}
                onChange={(event) => {
                  setDescripcion(event.target.value);
                }}
                className={classes.textField}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                id="input-Suplemento"
                label="Suplemento"
                type="text"
                variant="outlined"
                name="suplemento"
                value={suplemento}
                onChange={(event) => {
                  setSuplemento(event.target.value);
                }}
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {rowData.Moneda ? `${rowData.Moneda.Clave}` : ""}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={11}>
              <PickerMod
                id="PickeSalidas"
                label="Fecha prevista"
                selectedDate={selectDay}
                setSelectedDate={setSelectedDate}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                id="input-disponibilidad-fecha"
                label="Diponibilidad por fecha"
                type="number"
                variant="outlined"
                name="diponibilidad"
                value={disponibilidad}
                min="0"
                onChange={(event) => {
                  setDisponibilidad(event.target.value);
                }}
                className={classes.textField}
              />
            </Grid>
            <Grid item xs={12} className={classes.modalBotonesCenter}>
              <Button
                onClick={onAgregar}
                variant="contained"
                color="primary"
                className={classes.modalBoton}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <TablaFechas rows={arraySalidas} onDeleteFecha={onDeleteFecha} />
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12}>
          <TablaRegitro rows={salidasPaquetes} idPaquete={rowData.IdPaquete} Moneda={rowData.Moneda ? `${rowData.Moneda.Clave}` : ""} />
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={() => {
              onSave();
            }}
            variant="contained"
            color="primary"
            disabled={arraySalidas.length > 0 ? false : true}
            className={classes.modalBoton}
          >
            Guardar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default FPaquetesSalidas;
